import { RefObject, useEffect } from 'react';
import { useRafState } from 'react-use';

import { off, on } from './misc/util';

export interface State {
  x: number;
  y: number;
}

const useScroll = (ref: RefObject<HTMLElement | null | undefined>): State => {
  if (typeof ref !== 'object' || typeof ref.current === 'undefined') {
    console.error('`useScroll` expects a single ref argument.');
  }

  const [state, setState] = useRafState<State>({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const handler = () => {
      if (ref.current) {
        setState({
          x: ref.current.scrollLeft,
          y: ref.current.scrollTop,
        });
      }
    };

    if (ref.current) {
      on(ref.current, 'scroll', handler, {
        capture: false,
        passive: true,
      });
    }

    return () => {
      // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: The ref's value `.current` is accessed directly in the effect cleanup function.
      if (ref.current) {
        // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: The ref's value `.current` is accessed directly in the effect cleanup function.
        off(ref.current, 'scroll', handler);
      }
    };
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'setState'
  }, [ref]);

  return state;
};

export default useScroll;
